import { HttpRequest } from '../../../utils/httpClient';
import { AUTH_PATHS } from '../constants';
import config from '../../../config';

export const request = new HttpRequest(config.endpoints.auth);

export const authService = {
  login: async (credentials) => {
    const response = await request.post(credentials, AUTH_PATHS.LOGIN);
    if (response.status === 200) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Error logging in');
  },
  
  validateToken: async (token) => {
    try {
      const headers = {
        'Authorization': `Bearer ${token}`
      };
      const response = await request.get(AUTH_PATHS.VALIDATE, {}, headers);
      return response.status === 200;
    } catch (error) {
      return false;
    }
  },
  
  getUser: async (token) => {
    const headers = {
      'Authorization': `Bearer ${token}`
    };
    const response = await request.get(AUTH_PATHS.USER, {}, headers);
    if (response.status === 200) {
      return response.data.data;

    }
    throw new Error(response.data?.message || 'Error retrieving user data');
  },
}; 